/**
 * Store: Product Evaluation Copy
 * -----------------------------------------------------------------------------
 * - Tied to the product-evaluation-copy component.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    showErrorToast: false,
    initialData: null,
    confirmationData: null,
    successData: null,
    blockedData: null,
    errorData: null,
  }),

  getters: {

    /**
     * Get product evaluation Initial Data.
     * @returns {Object}
     */
    getInitialData(state) {
      return state.initialData
    },

    /**
     * Get product evaluation Confirmation Data.
     * @returns {Object}
     */
    getConfirmationData(state) {
      return state.confirmationData
    },

    /**
     * Get product evaluation Success Data.
     * @returns {Object}
     */
    getSuccessData(state) {
      return state.successData
    },

    /**
     * Get product evaluation Blocked Data.
     * @returns {Object}
     */
    getBlockedData(state) {
      return state.blockedData
    },

    /**
     * Get product evaluation Error Data.
     * @returns {Object}
     */
    getErrorData(state) {
      return state.errorData
    },
  },

  mutations: {

    /**
     * Set Initial Data.
     * @param {Object} data - Object with title title and description.
     */
    SET_INITIAL_DATA(state, data) {
      state.initialData = data
    },

    /**
     * Set Confirmation Data.
     * @param {Object} data - Object with confirmation title and description.
     */
    SET_CONFIRMATION_DATA(state, data) {
      state.confirmationData = data
    },

    /**
     * Set Success Data.
     * @param {Object} data - Object with success title and description.
     */
    SET_SUCCESS_DATA(state, data) {
      state.successData = data
    },

    /**
     * Set Blocked Data.
     * @param {Object} data - Object with blocked title and description.
     */
    SET_BLOCKED_DATA(state, data) {
      state.blockedData = data
    },

    /**
     * Set Error Data.
     * @param {Object} data - Object with error title and description.
     */
    SET_ERROR_DATA(state, data) {
      state.errorData = data
    },

    /**
     * Set if error toast should show.
     * @param {Boolean} value
     */
    SET_SHOW_ERROR(state, value) {
      state.showErrorToast = value
    },
  },

  actions: {

    /**
     * Commit Initial Data.
     * @param {Object} data - Object with initial title and description.
     */
    setInitialData({ commit }, data) {
      commit('SET_INITIAL_DATA', data)
    },

    /**
     * Commit Confirmation Data.
     * @param {Object} data - Object with confirmation title and description.
     */
    setConfirmationData({ commit }, data) {
      commit('SET_CONFIRMATION_DATA', data)
    },

    /**
     * Commit Success Data.
     * @param {Object} data - Object with success title and description.
     */
    setSuccessData({ commit }, data) {
      commit('SET_SUCCESS_DATA', data)
    },

    /**
     * Commit Blocked Data.
     * @param {Object} data - Object with blocked title and description.
     */
    setBlockedData({ commit }, data) {
      commit('SET_BLOCKED_DATA', data)
    },

    /**
     * Commit Error Data.
     * @param {Object} data - Object with error title and description.
     */
    setErrorData({ commit }, data) {
      commit('SET_ERROR_DATA', data)
    },

    /**
     * Commit Show Error Data.
     * @param {Boolean} value
     */
    setShowError({ commit }, value) {
      commit('SET_SHOW_ERROR', value)
    },
  },
}
